<template>
  <table class="slds-table slds-table_cell-buffer slds-table_bordered">
    <thead>
      <tr class="slds-line-height_reset">
        <th class="" scope="col">
          <div class="slds-truncate" :title="$t(`campaignDesigner.contentSelectionAndTag.${type}`)">
            {{$t(`campaignDesigner.contentSelectionAndTag.${type}`)}}
          </div>
        </th>
        <th class="" scope="col">
          <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.status')">
            {{$t('campaignDesigner.contentSelectionAndTag.status')}}
          </div>
        </th>
        <th class="" scope="col">
          <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.itemTypeDescription')">
            {{$t('campaignDesigner.contentSelectionAndTag.itemTypeDescription')}}
          </div>
        </th>
        <th class="" scope="col">
          <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.itemDescription')">
            {{$t('campaignDesigner.contentSelectionAndTag.itemDescription')}}
          </div>
        </th>
        <th class="" scope="col">
          <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.quantity')">
            {{$t('campaignDesigner.contentSelectionAndTag.quantity')}}
          </div>
        </th>
        <th class="" scope="col">
          <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.offerType')">
            {{$t('campaignDesigner.contentSelectionAndTag.offerType')}}
          </div>
        </th>
        <th class="" scope="col">
          <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.priceValue')">
            {{$t('campaignDesigner.contentSelectionAndTag.priceValue')}}
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, rowIndex) in items" :key="rowIndex">
        <td :data-label="$t(`campaignDesigner.contentSelectionAndTag.${type}`)">
          <div class="slds-truncate" :title="row[type]" v-if="type === 'mvs'">{{row.mvs}} - {{ mvsNames[row.mvs] }}</div>
          <div class="slds-truncate" :title="row[type]" v-else>{{ row.vin }}</div>
        </td>
        <td :data-label="$t('campaignDesigner.contentSelectionAndTag.status')">
          <div class="slds-truncate" :title="row.status" v-if="row.status && row.status.length">{{ $t(`churnScore.${row.status}`) }}</div>
          <div class="slds-truncate" :title="row.status" v-else>&nbsp;</div>
        </td>
        <td :data-label="$t('campaignDesigner.contentSelectionAndTag.itemTypeDescription')">
          <div class="slds-truncate" :title="row.itemTypeDescription">{{ row.itemTypeDescription }}</div>
        </td>
        <td :data-label="$t('campaignDesigner.contentSelectionAndTag.itemDescription')">
          <div class="slds-truncate" :title="row.itemDescription">{{ row.itemDescription }}</div>
        </td>
        <td :data-label="$t('campaignDesigner.contentSelectionAndTag.quantity')">
          <div class="slds-truncate" :title="row.quantity">{{ row.quantity }}</div>
        </td>
        <td :data-label="$t('campaignDesigner.contentSelectionAndTag.offerType')">
          <div class="slds-truncate" :title="row.offerType">{{ row.offerType }}</div>
        </td>
        <td :data-label="$t('campaignDesigner.contentSelectionAndTag.priceValue')">
          <div class="slds-truncate" :title="row.priceValue">{{ row.priceValue }}</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    items: Array,
    mvsNames: Object,
    type: String
  }
}
</script>
